import {hAreaCodeEnum} from '../reducers/env'

const COIN_EXPAND_AREA_CODES: ReadonlySet<hAreaCodeEnum> = new Set([
  hAreaCodeEnum.ar,
  hAreaCodeEnum.pt,
])

const POINT_EXPAND_AREA_CODES: ReadonlySet<hAreaCodeEnum> = new Set([
  hAreaCodeEnum.pt,
])

export const needCoinExpand = (areaCode?: hAreaCodeEnum): boolean =>
  areaCode !== undefined && COIN_EXPAND_AREA_CODES.has(areaCode)

export const needPointExpand = (areaCode?: hAreaCodeEnum): boolean =>
  areaCode !== undefined && POINT_EXPAND_AREA_CODES.has(areaCode)
